import { render } from "./Noticia.vue?vue&type=template&id=876572ec&scoped=true"
const script = {}

import "./Noticia.vue?vue&type=style&index=0&id=876572ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876572ec"]])

export default __exports__